import { render, staticRenderFns } from "./preguntas_x_institucion.vue?vue&type=template&id=ff20e604"
import script from "./preguntas_x_institucion.vue?vue&type=script&lang=js"
export * from "./preguntas_x_institucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports